export default {"src":"/_next/static/media/finance-trend-white.c8d6d123.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};